// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1EE7R","col":"CardReaderDesc_col__1_KTv","label":"CardReaderDesc_label__XtNj8"};